import React, { useState } from "react";

const Whatsapp = () => {
  const [open, setOpen] = useState(false);

  const numbers = [
    {
      label: "Service Commercial",
      phone: "212662358466",
      message:
        "Bonjour UNIK SYSTEM, j’aimerais obtenir des informations commerciales et une offre de prix sur vos produits.",
    },
    
    {
      label: "Support Technique",
      phone: "212679316871",
      message:
        "Bonjour UNIK SYSTEM, j’ai besoin d’assistance technique concernant l’installation ou la maintenance de vos solutions.",
    },
    {
      label: "Devis & Infos",
      phone: "212661931802",
      message:
        "Bonjour UNIK SYSTEM, je souhaite demander un devis et plus d’informations sur vos solutions.",
    },
  ];

  return (
    <div className="whatsapp-wrapper">
      {/* POPUP */}
      {open && (
        <div className="whatsapp-popup">
          <p className="popup-title">Contactez-nous sur WhatsApp</p>

          {numbers.map((item, index) => (
            <a
              key={index}
              href={`https://wa.me/${item.phone}?text=${encodeURIComponent(
                item.message
              )}`}
              target="_blank"
              rel="noopener noreferrer"
              className="popup-number"
            >
              <i className="fab fa-whatsapp"></i>
              <span>{item.label}</span>
            </a>
          ))}
        </div>
      )}

      {/* BUTTON */}
      <button
        className="whatsapp-btn"
        onClick={() => setOpen(!open)}
        aria-label="WhatsApp"
      >
        <i className="fab fa-whatsapp"></i>
      </button>
    </div>
  );
};

export default Whatsapp;
